import { useEffect, useMemo, useState } from "react";
import { getVenues, VenueType } from "../../../Services/Admin/Venues";

export type VenueOption = { id: string; name: string };

/**
 * Venuelistan som sensorpanelerna väljer ur.
 *
 * Sökningen ligger i panelens verktygsrad och inte i varje kort: en
 * <select> med hundra rader är obrukbar på en telefon, och båda
 * panelerna behövde samma avstudsade hämtning för att slippa en request
 * per tangenttryckning.
 */
export function useVenueOptions() {
  const [venues, setVenues] = useState<VenueType[]>([]);
  const [query, setQuery] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;

    const timer = setTimeout(() => {
      getVenues({ q: query.trim() || undefined, status: "active", limit: 100 })
        .then((page) => {
          if (alive) setVenues(page.items);
        })
        .catch((e: any) => {
          if (alive) setError(e?.message ?? "Could not load venues");
        });
    }, 200);

    return () => {
      alive = false;
      clearTimeout(timer);
    };
  }, [query]);

  const options = useMemo<VenueOption[]>(
    () =>
      venues
        .map((venue) => ({ id: venue.id, name: venue.name }))
        .sort((a, b) => a.name.localeCompare(b.name, "sv")),
    [venues]
  );

  return { options, query, setQuery, error };
}
